
document.addEventListener("DOMContentLoaded", function () {

  // 🔹 Live click for .slide-panel-button
  document.addEventListener("click", function (e) {
    const button = e.target.closest(".slide-panel-button");
    if (!button) return; // Exit if the click wasn’t on a slide-panel-button

    e.preventDefault();

    const targetSelector = button.getAttribute("data-target");
    const targetPanel = document.querySelector(targetSelector);
    if (!targetPanel) return;

    // Move the panel to the end of <body> (ensures top-level stacking)
    if (targetPanel.parentElement !== document.body) {
      document.body.appendChild(targetPanel);
    }

    // If this panel is already open → close it
    const isVisible = targetPanel.classList.contains("is-visible");
    document.querySelectorAll(".slide-panel").forEach((panel) => {
      panel.classList.remove("is-visible");
      panel.style.display = "none";
    });

    // Open only if it wasn’t already visible
    if (!isVisible) {
      targetPanel.style.display = "block";
      requestAnimationFrame(() => {
        targetPanel.classList.add("is-visible");
      });
    }
  });

  // 🔹 Live click for background or close button inside .slide-panel
  document.addEventListener("click", function (e) {
    const panel = e.target.closest(".slide-panel");
    if (
      (panel && e.target.classList.contains("slide-panel")) ||
      e.target.classList.contains("slide-panel-close")
    ) {
      panel.classList.remove("is-visible");
      setTimeout(() => {
        panel.style.display = "none";
      }, 400);
      e.preventDefault();
    }
  });
});

  
 
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  // Try to detect color name from variant title (e.g. "Red / M")
  const colorOption = variant.option1 || variant.title.split('/')[0];
  if (!colorOption) return;

  const selectedColor = colorOption.trim().toLowerCase().replace(/\s+/g, '-');

  // Hide/show media items based on color
  document.querySelectorAll('.custom_two_columns').forEach((item) => {
    const colorAttr = item.dataset.color;
    if (!colorAttr || colorAttr === selectedColor) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const selectedColor = document.querySelector('[data-color]')?.dataset.color;
  if (!selectedColor) return;

  document.querySelectorAll('.custom_two_columns').forEach((item) => {
    const colorAttr = item.dataset.color;
    if (!colorAttr || colorAttr === selectedColor) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });
});
function adjustOddImageLayout() {
  const visibleItems = Array.from(document.querySelectorAll('.custom_two_columns'))
    .filter(item => item.style.display !== 'none');

  // Reset all back to half-width first
  visibleItems.forEach(item => {
    item.classList.remove('medium-up--one-full');
    item.classList.add('medium-up--one-half');
  });

  // If count is odd → make the last one full width
  if (visibleItems.length % 2 !== 0) {
    const lastItem = visibleItems[visibleItems.length - 1];
    if (lastItem) {
      lastItem.classList.remove('medium-up--one-half');
      lastItem.classList.add('medium-up--one-full');
    }
  }
}
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const colorOption = variant.option1 || variant.title.split('/')[0];
  if (!colorOption) return;

  const selectedColor = colorOption.trim().toLowerCase().replace(/\s+/g, '-');

  document.querySelectorAll('.custom_two_columns').forEach((item) => {
    const colorAttr = item.dataset.color;
    if (!colorAttr || colorAttr === selectedColor) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });

  adjustOddImageLayout(); // 👈 Add this line
});
document.addEventListener('DOMContentLoaded', function () {
  const selectedColor = document.querySelector('[data-color]')?.dataset.color;
  if (!selectedColor) return;

  document.querySelectorAll('.custom_two_columns').forEach((item) => {
    const colorAttr = item.dataset.color;
    if (!colorAttr || colorAttr === selectedColor) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });

  adjustOddImageLayout(); // 👈 Add here too
});
 

 
 
/*
document.addEventListener('DOMContentLoaded', () => {
  // Run only on mobile
  if (window.innerWidth > 767) return;

  // Listen for variant change (Impulse triggers this)
  document.addEventListener('variant:change', (event) => {
    const variant = event?.detail?.variant;
    if (!variant) return;

    // Optional fade overlay for smoothness
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: #fff;
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 99999;
      pointer-events: none;
    `;
    document.body.appendChild(overlay);

    // Fade in overlay, then reload
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
      setTimeout(() => {
        window.location.reload();
      }, 200); // reload after short fade
    });
  });
});
*/